import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { SeasonResponse } from "~types/season.ts";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption> & {
  competitionId?: string;
};

const SelectSeason = ({ value, competitionId, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: SeasonResponse) =>
    (response?.data || []).map((x) => ({ label: x.nameLocal, value: x.seasonId }));

  const url = isEmpty(competitionId)
    ? `${sport}/o/${organizationId}/seasons`
    : `${sport}/o/${organizationId}/competitions/${competitionId}/seasons`;

  return (
    <InfinitySelect<SeasonResponse>
      {...props}
      url={url}
      searchParameter="nameLocalContains"
      sortByFieldName="nameLocal"
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.SEASON}
      permissionOperation={PermissionOperations.READ}
      resetOptionsDependencies={[competitionId]}
    />
  );
};

export default SelectSeason;
